import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Eyebrow from "@/components/common/Eyebrow";
import { COLLECTIONS } from "@/constants/homeContent";

export default function CuratedCollections() {
  return (
    <Box component="section" sx={{ maxWidth: 1400, mx: "auto", px: { xs: 3, lg: 6 }, pt: { xs: 6, md: 8 } }} data-testid="collections-section">
      <Box sx={{ display: "flex", alignItems: "flex-end", justifyContent: "space-between", mb: 3, gap: 2, flexWrap: "wrap" }}>
        <Box>
          <Eyebrow sx={{ mb: 1 }}>Curated collections</Eyebrow>
          <Typography component="h2" className="font-serif-display" sx={{ fontSize: { xs: 26, md: 32 } }}>Find a villa for every kind of escape</Typography>
        </Box>
        <Box component={Link} to="/villas" sx={{ display: "flex", alignItems: "center", gap: 0.5, fontSize: 14, fontWeight: 500, color: "text.primary", textDecoration: "none", "&:hover": { color: "primary.main" } }}>
          View all collections <ArrowRight size={14} />
        </Box>
      </Box>
      <Box sx={{ display: "grid", gridTemplateColumns: { xs: "repeat(2, 1fr)", sm: "repeat(3, 1fr)", md: "repeat(6, 1fr)" }, gap: 2 }}>
        {COLLECTIONS.map(({ label, Icon, category, image }) => (
          <Box
            key={label}
            component={Link}
            to={category ? `/villas?category=${category}` : "/villas"}
            data-testid={`collection-tile-${label.toLowerCase().replace(/\s+/g, "-")}`}
            sx={{ position: "relative", aspectRatio: "4 / 3", borderRadius: 3, overflow: "hidden", textDecoration: "none", display: "block", "&:hover img": { transform: "scale(1.06)" } }}
          >
            <Box component="img" src={image} alt="" sx={{ width: "100%", height: "100%", objectFit: "cover", transition: "transform 0.5s ease" }} />
            <Box sx={{ position: "absolute", inset: 0, background: "linear-gradient(180deg, rgba(0,0,0,0.1) 0%, rgba(0,0,0,0.6) 100%)" }} />
            <Box sx={{ position: "absolute", top: 12, left: 12, width: 36, height: 36, borderRadius: "50%", bgcolor: "rgba(255,255,255,0.92)", display: "flex", alignItems: "center", justifyContent: "center" }}>
              <Icon size={16} className="text-gold" />
            </Box>
            <Typography sx={{ position: "absolute", left: 12, bottom: 12, right: 12, color: "#fff", fontWeight: 600, fontSize: { xs: 12.5, md: 14 } }}>
              {label}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
}
